module.exports = __webpack_public_path__ + "fonts/ralewaylightitalic.a296e76.ttf";